/*
This file is for View Properties.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 29/11/2017 07:14 PM
*/
/*
 * ViewProperties class stores some default constant value of View
 */
const ViewProperties = () => {
    const that = {
        player: {
            default: {
                autoplay: 'autoplay',
                name: '',
                nameDisplayMode: '',
                frameFitMode: 'bestFit',
                skin: 'default',
                class: '',
                height: '240px',
                width: '320px',
                minHeight: '200px',
                minWidth: '250px',
                aspectRatio: '16:9',
                volume: 5,
                media: '',
                loader: {
                    show: true,
                    style: 'default',
                    class: '',
                },
            },
        },
        brand: {
            default: {
                display: true,
                url: 'http://www.vcloudx.com',
                logo: '/assets/favicon.png',
                show: true,
                target: '_blank',
                title: 'VCloudX Infotech',
            },
        },
        toolbar: {
            default: {
                skin: 'default',
                buttons: {
                    play: true,
                    resize: true,
                    share: true,
                    mic: true,
                    volume: true,
                    mute: true,
                    record: true,
                    playtime: true,
                    zoom: true,
                },
                position: 'bottom',
                class: '',
                displayMode: true,
                autoDisplayTimeout: 0,
            },
        },
    };

    return that;
};
export default ViewProperties;



//////////////////
// WEBPACK FOOTER
// ./src/views/ViewProperties.js
// module id = 16
// module chunks = 0